<template>
	<div>
		<modaluser v-model="dialog" :propAdd='paramProp' :val = 'val' :filter="{limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}"/>
		<modalpassword type="warehouse" ref="modalPassword" :selectedUser="selectedUser" :filter="{limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}"/>
		<modalconfirm ref="modalconfirmUser" @action="deleteData"/>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Pengguna</div>
		</div>
		<v-card class="mt-3 mb-3" outlined>
			<v-list color="deep-purple lighten-5" dark class="pa-3">
				<v-list-item dense class="px-1">
					<v-btn light depressed class="primary" @click.stop="() => {dialog=true; paramProp='tambah'; val= {};}">
						<v-icon>mdi-plus-circle</v-icon>
						<div class="pl-2 text-capitalize">Tambah Pengguna</div>
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn class="primary" text dark @click="dropfilter = !dropfilter">
						<v-icon>mdi-filter</v-icon>
						<div class="pl-2 text-capitalize">Filter</div>
					</v-btn>
				</v-list-item>
			</v-list>
		</v-card>
		<v-slide-y-transition>
			<v-card outlined class="mb-3" v-if="dropfilter">
				<filterComponent @searchFilter="searchFilter" @onResetFilter="onResetFilter"></filterComponent>
			</v-card>
		</v-slide-y-transition>
		<v-card outlined>
			<v-data-table loading :headers="headers" :items="userResults" hide-default-footer :options.sync="option" :server-items-length="userPagination.total_data" disable-pagination>
				<template v-slot:item.user_name="{ item }">
					<div class="d-flex">
						<v-avatar color="indigo" size="36">
							<img class="avatar" :src=" item.user_image ? item.user_image :'/assets/user/profile-pict-menolak-big.png'">
						</v-avatar>
						<div class="pl-2 my-auto">{{ item.user_name }}</div>
					</div>
				</template>
				<template v-slot:item.contact="{ item }">
					<div class="pt-2">{{ item.user_mobilephone }}</div>
					<div class="pb-2">{{ item.user_email }}</div>
				</template>
				<template v-slot:item.user_is_active="{ item }">
					<v-switch v-model="item.user_is_active" @change="editStatus(item)"></v-switch>
				</template>
				<template v-slot:item.username="{ item }">
					<div class="pt-2">{{ item.user_username }}</div>
					<div class="pb-2 text-capitalize">{{ item.user_type }}</div>
				</template>
				<template v-slot:item.action="{ item }">
					<v-tooltip bottom v-if="userData.user_id == item.user_id">
						<template v-slot:activator="{ on, attrs }">
							<v-btn class="mr-1" fab dark x-small depressed color="indigo" v-bind="attrs" v-on="on" @click.stop="goToProfile">
								<v-icon dark>mdi-pencil</v-icon>
							</v-btn>
						</template>
						<span>Edit</span>
					</v-tooltip>
					<v-tooltip bottom v-if="userData.user_id != item.user_id">
						<template v-slot:activator="{ on, attrs }">
							<v-btn class="mr-1" fab dark x-small depressed color="indigo" v-bind="attrs" v-on="on" @click.stop="ubah(item)">
								<v-icon dark>mdi-pencil</v-icon>
							</v-btn>
						</template>
						<span>Edit</span>
					</v-tooltip>
					<v-tooltip bottom v-if="userData.user_id != item.user_id">
						<template v-slot:activator="{ on, attrs }">
							<v-btn class="mr-1" fab dark x-small depressed color="amber darken-4" v-bind="attrs" v-on="on" @click.stop="() => { $refs.modalPassword.show(); selectedUser = item.user_id}">
								<v-icon dark>mdi-key-variant</v-icon>
							</v-btn>
						</template>
						<span>Ubah Kata Sandi</span>
					</v-tooltip>
					<v-tooltip bottom v-if="userData.user_id != item.user_id">
						<template v-slot:activator="{ on, attrs }">
							<v-btn class="mr-1" fab dark x-small depressed color="pink" v-bind="attrs" v-on="on" @click.stop="showConfirmation(item.user_id, item.user_name)">
								<v-icon dark>mdi-delete</v-icon>
							</v-btn>
						</template>
						<span>Hapus</span>
					</v-tooltip>
				</template>
				<template v-slot:progress>
					<div>
					</div>
				</template>
				<template v-slot:loading>
					<div class="py-3" v-if="!userPagination">
						<loading-data></loading-data>
					</div>
					<div class="py-3" v-else>
						<not-found></not-found>
					</div>
				</template>
			</v-data-table>
		</v-card>
		<div class="pt-5">
			<v-row v-if="userPagination">
				<v-col cols="12" md="11" class="py-0 d-flex justify-end">
					<v-pagination v-model="page" :length="userPagination.total_page" @input="changePage" total-visible="7" circle class="d-flex justify-end"></v-pagination>
				</v-col>
				<v-col cols="12" md="1" class="py-0 pl-0">
					<v-autocomplete v-if="userResults.length > 0" :items="listLimit" v-model="limit" hide-details class="mt-0" label="Item"></v-autocomplete>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
import modaluser from '@/views/MLwarehouse/user/ModalUserTree'
import modalpassword from '@/views/MLwarehouse/user/ModalPassword'
import {mapActions,  mapState, mapMutations} from 'vuex'

export default {
	inject: ['theme'],
	components: {
		modaluser, modalpassword
	},
	data() {
		return {
			theactive:[],
			sortBy: 'user_name',
			sortDir: 'ASC',
			selectedUser:'',
			page: 1,
			limit: "10",
			listLimit: [ '5', '10', '20', '50', '100' ],
			paramProp: '',
			propDelete: '',
			val: {},
			edit: 'edit',
			dialog: false,
			dropfilter: false,
			search: '',
			headers: [
			{ text: 'Nama', align: 'start', value: 'user_name'},
			{ text: 'Kontak', value: 'contact', sortable: false},
			{ text: 'Username', value: 'username' },
			{ text: 'Aktif', value: 'user_is_active' },
			{ text: 'Aksi', value: 'action', sortable: false, },
			],
			filterData: [{
				type: 'text',
				label: 'Nama',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'user_name'
				}
			}, {
				type: 'text',
				label: 'No Hp',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'user_mobilephone'
				}
			}, {
				type: 'text',
				label: 'Email',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'user_email'
				}
			}, {
				type: 'text',
				label: 'Username',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'user_username'
				}
			}, {
				type: 'selection',
				label: 'Tipe',
				item: ['superuser', 'administrator'],
				filter: {
					value: '',
					comparison: '=',
					type: 'string',
					field: 'user_type'
				}
			},
			],
			params:[],
			paramStatus : {
				id : '',
				status : ''
			}
		}
	},
	props: {
	},
	computed: {
		...mapState('auth', ['userData']),
		...mapState('userList', ['userResults', 'userPagination', 'konfirmResponse', 'OptionType']),
	},
	methods: {
		...mapActions('userList', ['getUser', 'add', 'delete', 'getTypeOption', 'status']),
		...mapActions('menuWH', ['getMenu']),
		...mapMutations('userList', ['clearDataUser']),
		...mapMutations(['setOverlay', 'setFilter']),

		getData() {
			this.getUser(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		editStatus(stat) {
			this.paramStatus.id = stat.user_id
			if(stat.user_is_active == false) {
				this.paramStatus.status = 'inactive'
			} else {
				this.paramStatus.status = 'active'
			}
			this.status(this.paramStatus).then(() => {
				this.getData()
			})
		},
		ubah(item) {
			this.val = item;
			this.dialog = true;
			this.paramProp = 'edit';
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		searchFilter(data) {
			this.params = data
			this.getData()
		},
		onResetFilter() {
			this.params = []
			this.getData()
		},
		showConfirmation(id, name) {
			this.propDelete = id
			let msg = `Yakin ingin menghapus ${name}?`
			this.$refs.modalconfirmUser.setMessage(msg)
			this.$refs.modalconfirmUser.showConfirm()
		},
		async deleteData() {
			await this.setOverlay(true)
			await this.$refs.modalconfirmUser.hideConfirm()
			await this.delete(this.propDelete).then( () => {
				this.page = 1
				this.getData()
			})
			await this.setOverlay(false)
		},
		goToProfile() {
			this.$router.push('profile')
		}
	},
	async created() {
		await this.setFilter(this.filterData)
		await this.getData()
		await this.getMenu()
		await this.$store.dispatch('setPageTitle', `User`)
	},
	beforeDestroy() {
		this.clearDataUser()
	},
	watch: {
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'DESC' : 'ASC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getData()
			}
		}
	}
}
</script>

<style>
tbody tr:nth-of-type(even) {
	background-color: rgba(0, 0, 0, .05);
}
.v-avatar .avatar {
	object-position: center;
	object-fit: cover;
}
</style>